import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, ViewController, Events } from 'ionic-angular';
import { CoPatronDetailsPage } from '../co-patron-details/co-patron-details';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';

/**
 * Generated class for the CoPatronLookupResultsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-patron-lookup-results',
  templateUrl: 'co-patron-lookup-results.html',
})
export class CoPatronLookupResultsPage {
  patronInfo: any;
  searchTerm: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, private modalCtrl : ModalController, private viewCtrl : ViewController, private events : Events, private timeout : TimeoutFunctionsProvider) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this.patronInfo = this.navParams.data.patron;
    this.searchTerm = this.navParams.data.searchTerm;
  }

  goToPatron(patron){
    this.viewCtrl.dismiss().catch(err=>{});

    let modal = this.modalCtrl.create(CoPatronDetailsPage, {patron: patron}, {cssClass: 'custom-medium-wide-modal'});
    modal.present();
  }


}



// WEBPACK FOOTER //
// ./src/pages/co-patron-lookup-results/co-patron-lookup-results.ts